"use client";

import Link from "next/link";

/**
 * Login / overlay copy when the account was archived. Matches Instagram,
 * Discord, and Slack: say the account is gone, then point to support.
 */
export function AccountDeletedCopy() {
  return (
    <>
      This account has been deleted. If you believe this is an error, please{" "}
      <Link href="/support" className="font-semibold underline underline-offset-2">
        contact support
      </Link>.
    </>
  );
}
